import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Account: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--account')}
    width="20"
    height="22"
    viewBox="0 0 20 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g id="Action" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Action/-Account-(Normal)"
        transform="translate(-6.000000, -4.000000)"
        stroke="#000000"
        strokeWidth="1.5"
      >
        <g id="icon" transform="translate(7.000000, 5.000000)">
          <ellipse
            id="Oval"
            cx="8.91"
            cy="5.38695652"
            rx="4.86"
            ry="4.93043478"
          />
          <path
            d="M17.82,20.5434783 C17.82,16.4589724 13.8308571,13.1478261 8.91,13.1478261 C3.98914288,13.1478261 0,16.4589724 0,20.5434783"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default Account;
